import React, { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import SearchIcon from '../components/Icon/SearchIcon'
import DropdownIcon from '../components/Icon/DropdownIcon'
import Left from '../components/Icon/Left'
import Right from '../components/Icon/Right'
import Filter from '../components/Icon/Filter'
import Dollar from '../components/Icon/Dollar'
import PPMori from "../assets/fonts/PPMori-Regular.otf";
import { useData } from '../context/DataProvider'
import ClearIcon from '../components/Icon/Clear'
import ProductModal from '../components/ProductModal'
import { CrossIcon } from '../components/Icon/CrossIcon'
import { Warn } from '../components/Icon/Warn'
import BackToTop from '../components/BackToTop'
import BackToTopIcon from '../components/Icon/arrow-circle-top-svgrepo-com.svg'
import { cosmeticIQApi } from '../service/api'
import RedirectModal from '../components/RedirectModal'
import Loader from '../components/Loader'
import SaveReport from '../components/Icon/SaveReport'
import SaveViewModal from '../components/SaveViewModal'
import { useLocation } from 'react-router-dom'
import SavedFull from '../components/Icon/SavedFull'
import CsvModal from '../components/CsvModal'
import DownloadIcon from '../components/Icon/DownloadIcon'


const NewlyLaunchedProducts = (props) => {
  const { data: fetchedData ,fetchNewProductsByDays,sessionExpired,getSegments,setData} = useData();
  const filtersRef = useRef(null);
  const [newProductsData, setNewProductsData] = useState(props.newProducts || fetchedData?.newProducts || []);
const [isDaysOpen, setIsDaysOpen] = useState(false);
const [isCsvModalOpen,setIsCsvModalOpen] = useState(false);
const [selectedDays, setSelectedDays] = useState(30);

const [segments, setSegments] = useState([]);
const [selectedSegment, setSelectedSegment] = useState(null); // only one allowed
const [isSegmentOpen, setIsSegmentOpen] = useState(false);
const dropdownContainerRef = useRef(null);
const location = useLocation();
  const prod = location?.state?.prod;
const [isRestoring, setIsRestoring] = useState(!!prod?.docId);
const findMatchIdRef = useRef(0);



useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      dropdownContainerRef.current &&
      !dropdownContainerRef.current.contains(event.target)
    ) {
      setIsDaysOpen(false);
      setIsSegmentOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
useEffect(() => {
  const fetchSegments = async () => {
    try {
      const res = await getSegments();
      
      
      setSegments(res || []);
    } catch (err) {
      console.log("Failed to load segments", err);
    }
  };

  fetchSegments();
}, []);
const daysOptions = [
  { label: "1 Month", value: 30 },
  { label: "3 Months", value: 90 },
  { label: "6 Months", value: 180 },
  { label: "12 Months", value: 365 }
];
  const [visibleProducts, setVisibleProducts] = useState(50);
 const [showBackToTop, setShowBackToTop] = useState(false);
  const tableContainerRef = useRef(null);

  const handleLoadMore = () => {
    setVisibleProducts((prev) => prev + 50);
  };
const latestRequestIdRef = useRef(0);

const loadNewProducts = async (days, segment) => {
  const requestId = ++latestRequestIdRef.current;

  setLoading(true);

  try {
    const products = await fetchNewProductsByDays(days, segment);

    if (requestId === latestRequestIdRef.current) {
      setNewProductsData(products);
    }
  } catch (error) {

    if (requestId === latestRequestIdRef.current) {
      console.log(error);
    }
  } finally {
    
    if (requestId === latestRequestIdRef.current) {
      setLoading(false);
    }
  }
};
  const handleDaysSelect = async (option) => {
    clearFilters();
  const days = option.value;

  setSelectedDays(days);
  setIsDaysOpen(false);

  await loadNewProducts(days, selectedSegment?.segment_id);
};
const handleSegmentSelect = async (segment) => {
  clearFilters();
  setSelectedSegment(segment);
  setIsSegmentOpen(false);

  await loadNewProducts(selectedDays, segment?.segment_id);
};
  
    let data = {}
  if(props.newProducts) {
    data.newProducts = props.newProducts;
  } else {
    data.newProducts = newProductsData;
  }



  const [activeSortKey, setActiveSortKey] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [alreadySaved,setAlreadySaved] = useState(false);
  const [selectedBrandOrigins, setSelectedBrandOrigins] = useState([]);
  const [selectedPrices, setSelectedPrices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrandRetailers, setSelectedBrandRetailers] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [selectedTrends, setSelectedTrends] = useState([]);
  const [selectedTimeRange, setSelectedTimeRange] = useState(null);
  const [loading,setLoading] = useState(false);
  const [isOn, setIsOn] = useState(true);
  const [isOnProducts, setIsOnProducts] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpenSaveViewModal, setIsOpenSaveViewModal] = useState(false);
  const itemsPerPage = 50;
  const firstRowRef = useRef(null);
  

  const [selectedProduct, setSelectedProduct] = useState(null);
  
  
  const restoredRef = useRef(false);

useEffect(() => {
  if (!prod || restoredRef.current) return;

  const filters = prod.filters || [];
  const hasSegmentFilter = filters.some(f => f.filter === 'Segment');

  if (hasSegmentFilter && segments.length === 0) return;

  restoredRef.current = true;
  setIsRestoring(true); 

  const run = async () => {
    const byFilter = {};
    filters.forEach(f => {
      if (!byFilter[f.filter]) byFilter[f.filter] = [];
      byFilter[f.filter].push(f.option);
    });

    let restoredDays = selectedDays;
    if (byFilter['Time Period']) {
      const match = daysOptions.find(opt => opt.label === byFilter['Time Period'][0]);
      if (match) {
        restoredDays = match.value;
        setSelectedDays(match.value);
      }
    }

    let restoredSegment = null;
    if (byFilter['Segment']) {
      restoredSegment = segments.find(s => s.segment_name === byFilter['Segment'][0]) || null;
      setSelectedSegment(restoredSegment);
    }

    if (byFilter['Search']) setSearchTerm(byFilter['Search'][0]);
    if (byFilter['Brand']) setSelectedBrands(byFilter['Brand']);
    if (byFilter['Brand Origin']) setSelectedBrandOrigins(byFilter['Brand Origin']);
    if (byFilter['Price']) setSelectedPrices(byFilter['Price']);
    if (byFilter['Category']) setSelectedCategories(byFilter['Category']);
    if (byFilter['Retailer History']) setSelectedBrandRetailers(byFilter['Retailer History']);
    if (byFilter['Attribute']) setSelectedAttributes(byFilter['Attribute']);
    if (byFilter['Trend']) setSelectedTrends(byFilter['Trend']);
    if (byFilter['New Launch']) setSelectedTimeRange(byFilter['New Launch'][0].split(' ')[0]);
    if (byFilter['Discontinued']) setIsOn(false);
    if (byFilter['Reformulation/Repackaging']) setIsOnProducts(false);

    await loadNewProducts(restoredDays, restoredSegment?.segment_id); 
    setIsRestoring(false); 
  };

  run();
}, [prod, segments]);

const filtersMatch = (filtersA = [], filtersB = []) => {
  if (filtersA.length !== filtersB.length) return false;

  const normalize = (arr) =>
    [...arr]
      .map(f => `${f.filter}::${f.option}`)
      .sort();

  const a = normalize(filtersA);
  const b = normalize(filtersB);

  return a.every((val, index) => val === b[index]);
};

const findMatchingSavedView = (currentFilters, savedViews = []) => {
  return savedViews.find(view => filtersMatch(view.filters, currentFilters)) || null;
};

const isFilter = selectedAttributes.length > 0  || selectedBrandOrigins.length > 0 || selectedCategories.length > 0 || selectedBrands.length > 0 || selectedPrices.length > 0 || selectedBrandRetailers.length > 0 || selectedTrends.length > 0 || searchTerm || selectedTimeRange || !isOn;
  useEffect(() => {
  setCurrentPage(1);
}, [searchTerm, selectedBrands, selectedCategories, selectedPrices]);
  useEffect(() => {
    const handleScroll = () => {
      if (tableContainerRef.current) {
        const scrollTop = tableContainerRef.current.scrollTop;
        setShowBackToTop(scrollTop > 300);
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);


  const scrollToTop = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const handleRowClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };
 

  const toggleBrandSelection = (brand) => {
    setSelectedBrands(prev => 
      prev.includes(brand) 
        ? prev.filter(b => b !== brand)
        : [...prev, brand]
    );
  };
    const toggleBrandOriginSelection = (brandOrigin) => {
    setSelectedBrandOrigins(prev => 
      prev.includes(brandOrigin) 
        ? prev.filter(b => b !== brandOrigin)
        : [...prev, brandOrigin]
    );
  };

  const togglePriceSelection = (price) => {
    setSelectedPrices(prev => 
      prev.includes(price) 
        ? prev.filter(p => p !== price)
        : [...prev, price]
    );
  };

  const toggleCategorySelection = (category) => {
    setSelectedCategories(prev => 
      prev.includes(category) 
        ? prev.filter(c => c !== category)
        : [...prev, category]
    );
  };
    const toggleBrandRetailerSelection = (brand_retailer) => {
    setSelectedBrandRetailers(prev => 
      prev.includes(brand_retailer) 
        ? prev.filter(c => c !== brand_retailer)
        : [...prev, brand_retailer]
    );
  };

  const toggleAttributeSelection = (attribute) => {
    setSelectedAttributes(prev => 
      prev.includes(attribute) 
        ? prev.filter(a => a !== attribute)
        : [...prev, attribute]
    );
  };
  const toggleTrendSelection = (trend) => {
    setSelectedTrends(prev => 
      prev.includes(trend) 
        ? prev.filter(a => a !== trend)
        : [...prev, trend]
    );
  };
const clearFilters = () => {
  setOpenDropdown(null);
    setSelectedBrands([]);
    setSelectedTrends([]);
    setSelectedBrandOrigins([]);
    setSelectedPrices([]);
    setSelectedBrandRetailers([]);
    setSelectedCategories([]);
    setSelectedAttributes([]);
    setSelectedTimeRange(null);
    setSearchTerm("");
  };
  useEffect(() => {
  const handleClickOutside = (e) => {
    if (filtersRef.current && !filtersRef.current.contains(e.target)) {
      setOpenDropdown(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

  const handleSortChange = (sortKey) => {
    if (activeSortKey === sortKey) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setActiveSortKey(sortKey);
      setSortDirection("asc");
    }
  };

const productMatches = (product, skip) => {
  const lowerSearchTerm = searchTerm.toLowerCase();

  const m = {
    search:
      product.name.toLowerCase().includes(lowerSearchTerm) ||
      product.brand.toLowerCase().includes(lowerSearchTerm),

    prices:
      selectedPrices.length === 0 ||
      selectedPrices.some(price => price.length === parseInt(product.priceRange || '0')),

    brands:
      selectedBrands.length === 0 || selectedBrands.includes(product.brand),

    origins:
      selectedBrandOrigins.length === 0 || selectedBrandOrigins.includes(product.brand_origin),

    categories:
      selectedCategories.length === 0 ||
      product.categories.some(cat => selectedCategories.includes(cat.name)),

    retailers:
      selectedBrandRetailers.length === 0 ||
      product.brand_retailers.some(r => selectedBrandRetailers.includes(r.name)),

    trends:
      selectedTrends.length === 0 ||
      product.attributes.some(attr => selectedTrends.includes(attr.name)),

    attributes:
      selectedAttributes.length === 0 ||
      product.attributes.some(attr => selectedAttributes.includes(attr.name)),

    time:
      !selectedTimeRange ||
      (() => {
        const thresholdDate = new Date();
        thresholdDate.setMonth(thresholdDate.getMonth() - parseInt(selectedTimeRange));
        return new Date(product.date_launched) > thresholdDate;
      })(),
  };

  const extra = props.newProducts
    ? isOn || product.discontinued !== "1"
    : isOnProducts ||
      !product.attributes.some(a => a.name === 'Reformulation' || a.name === 'Repackaging');

  return extra && Object.keys(m).every(k => k === skip || m[k]);
};

const filteredProducts = data.newProducts.filter(p => productMatches(p));
const productsFor = (skip) => data.newProducts.filter(p => productMatches(p, skip));

const sortAlpha = (arr) => arr.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

const uniqueBrands = sortAlpha([
  ...new Set(productsFor('brands').map(p => p.brand)),
]);

const uniqueBrandOrigins = sortAlpha([
  ...new Set(productsFor('origins').map(p => p.brand_origin).filter(Boolean)),
]);

const priceOptions = ["1", "2", "3", "4"].filter(p =>
  productsFor('prices').some(prod => parseInt(prod.priceRange || '0') === parseInt(p))
);

const uniqueCategories = selectedSegment?.categories
  ? sortAlpha(selectedSegment.categories.map(cat => cat.category_name))
  : sortAlpha([
      ...new Set(productsFor('categories').flatMap(p => p.categories.map(cat => cat.name))),
    ]);

const uniqueBrandRetailers = sortAlpha([
  ...new Set(productsFor('retailers').flatMap(p => p.brand_retailers.map(r => r.name))),
]);

const uniqueAttributes = sortAlpha([
  ...new Set(
    productsFor('attributes').flatMap(p =>
      p.attributes
        .filter(attr => attr.type !== 'Internal' && attr.type !== 'Trend')
        .map(attr => attr.name)
    )
  ),
]);

const uniqueTrends = sortAlpha([
  ...new Set(
    productsFor('trends').flatMap(p =>
      p.attributes.filter(attr => attr.type === 'Trend').map(attr => attr.name)
    )
  ),
]);

  const renderMultiSelectDropdown = (
    isOpen, 
    setIsOpen, 
    selectedOptions, 
    options, 
    toggleSelection, 
    placeholder
  ) => (
    <DropdownWrapper >
      <DropdownInput 
        style={{
          background: selectedOptions.length > 0 
            ? 'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)' 
            : '#FFFFFF'
        }} 
       onClick={() =>
  setOpenDropdown(openDropdown === placeholder ? null : placeholder)
}

      >
        
        {selectedOptions.length > 0 
          ? selectedOptions.length > 1 ? 'Mulitple Options Selected'
          : selectedOptions[0] : placeholder}
        <DropdownIcon />
      </DropdownInput>
      <OptionsList isOpen={openDropdown === placeholder}>
  {options.length === 0 ? (
    <DropdownOption
      style={{ cursor: 'default', color: '#20232799', borderRadius: 8 }}
      onClick={(e) => e.stopPropagation()}
    >
      No options available
    </DropdownOption>
  ) : (
    options.map((option, index) => (
      <DropdownOption
        key={option}
        onClick={() => toggleSelection(option)}
        style={{
          backgroundColor: selectedOptions.includes(option) ? '#E0F2FE' : 'white',
          borderTopLeftRadius: index === 0 ? "8px" : "0",
          borderTopRightRadius: index === 0 ? "8px" : "0",
          borderBottomLeftRadius: index === options.length - 1 ? "8px" : "0",
          borderBottomRightRadius: index === options.length - 1 ? "8px" : "0",
        }}
      >
        {option}
        {selectedOptions.includes(option) && '✓'}
      </DropdownOption>
    ))
  )}
</OptionsList>
    </DropdownWrapper>
  );
  const renderMultiSelectDropdown3 = (
    isOpen, 
    setIsOpen, 
    selectedOptions, 
    options, 
    toggleSelection, 
    placeholder
  ) => (
    <DropdownWrapper style={{width:244,height:44}}>
      <DropdownInput 
        style={{
          background: selectedOptions.length > 0 
            ? 'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)' 
            : '#FFFFFF'
        }} 
       onClick={() =>
  setOpenDropdown(openDropdown === placeholder ? null : placeholder)
}

      >
        
        {selectedOptions.length > 0 
          ? selectedOptions.length > 1 ? 'Mulitple Options Selected'
          : selectedOptions[0] : placeholder}
        <DropdownIcon />
      </DropdownInput>
      <OptionsList isOpen={openDropdown === placeholder}>
        {options.map((option, index) => (
          <DropdownOption
            key={option}
            onClick={() => toggleSelection(option)}
            style={{
              backgroundColor: selectedOptions.includes(option) 
                ? '#E0F2FE' : 'white',
              borderTopLeftRadius: index === 0 ? "8px" : "0",
              borderTopRightRadius: index === 0 ? "8px" : "0",
              borderBottomLeftRadius: index === options.length - 1 ? "8px" : "0",
              borderBottomRightRadius: index === options.length - 1 ? "8px" : "0",
              
            }}
          >
            {option}
            {selectedOptions.includes(option) && '✓'}
          </DropdownOption>
        ))}
      </OptionsList>
    </DropdownWrapper>
  );
  const renderMultiSelectDropdown2 = (
    isOpen, 
    setIsOpen, 
    selectedOptions, 
    options, 
    toggleSelection, 
    placeholder
  ) => (
    <DropdownWrapper style={{flex:1,padding:0}}>
      <DropdownInput 
        style={{
          background: selectedOptions.length > 0 
            ? 'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)' 
            : '#FFFFFF'
        }} 
       onClick={() =>
  setOpenDropdown(openDropdown === placeholder ? null : placeholder)
}

      >
        
        {selectedOptions.length > 0 
          ? selectedOptions.length > 1 ? 'Mulitple Options Selected'
          : selectedOptions[0] : placeholder}
        <DropdownIcon />
      </DropdownInput>
      <OptionsList isOpen={openDropdown === placeholder}>
        {options.map((option, index) => (
          <DropdownOption
            key={option}
            onClick={() => toggleSelection(option)}
            style={{
              backgroundColor: selectedOptions.includes(option) 
                ? '#E0F2FE' : 'white',
              borderTopLeftRadius: index === 0 ? "8px" : "0",
              borderTopRightRadius: index === 0 ? "8px" : "0",
              borderBottomLeftRadius: index === options.length - 1 ? "8px" : "0",
              borderBottomRightRadius: index === options.length - 1 ? "8px" : "0",
              
            }}
          >
            {option}
            {selectedOptions.includes(option) && '✓'}
          </DropdownOption>
        ))}
      </OptionsList>
    </DropdownWrapper>
  );
  const getSortIcon = (sortKey) => {
    return (
      <FilterButton
        onClick={() => handleSortChange(sortKey)}
        style={{
          transform:
            activeSortKey === sortKey && sortDirection === "desc"
              ? "rotate(180deg)"
              : "none",
        }}
      >
        <Filter
          style={{
            color: activeSortKey === sortKey ? "#3B82F6" : "inherit",
          }}
        />
      </FilterButton>
    );
  };
  const getPaginationRange = (currentPage, totalPages) => {
  const delta = 2; 
  const range = [];
  const rangeWithDots = [];
  let l;

  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 || 
      i === totalPages || 
      (i >= currentPage - delta && i <= currentPage + delta)
    ) {
      range.push(i);
    }
  }

  
  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l > 2) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
};

const isSmallScreen = window.innerWidth < 1600 && !props.newProducts;
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (!activeSortKey) return 0;
    const order = sortDirection === "asc" ? 1 : -1;
  
    switch (activeSortKey) {
      case "dateLaunched":
        return order * (new Date(a.date_launched) - new Date(b.date_launched));
      case "dateAdded":
        return order * (new Date(a.date_created.split(' ')[0]) - new Date(b.date_created.split(' ')[0]));  
      case "price":
        return order * (parseInt(a.priceRange) - parseInt(b.priceRange));
      case "name":
      case "brand":
        return order * a[activeSortKey].localeCompare(b[activeSortKey]);
      case "category":
        return order * (a.categories[0]?.name || '').localeCompare(b.categories[0]?.name || '');
      case "brand_retailers":
        return order * (a.brand_retailers[0]?.name || '').localeCompare(b.brand_retailers[0]?.name || '');
        case "attribute":
        const aAttr = a.attributes?.filter(attr => attr.type !== 'Internal' && attr.type !== 'Trend')[0]?.name || '';
        const bAttr = b.attributes?.filter(attr => attr.type !== 'Internal' && attr.type !== 'Trend')[0]?.name || '';
        return order * aAttr.localeCompare(bAttr);
          case "trend":
        const aTrend = a.attributes?.filter(attr => attr.type === 'Trend')[0]?.name || '';
        const bTrend = b.attributes?.filter(attr => attr.type === 'Trend')[0]?.name || '';
        return order * aTrend.localeCompare(bTrend);
          case "brand_origin":
        return order * (a.brand_origin[0] || '').localeCompare(b.brand_origin[0] || ''); 
      case "ingredients":
        return order * (a.ingredients[0] || '').localeCompare(b.ingredients[0] || ''); 
        default:
        return 0;
    }
  });
  const startIndex = (currentPage - 1) * itemsPerPage;

const paginatedProducts = sortedProducts.slice(
  startIndex,
  startIndex + itemsPerPage
);
useEffect(() => {
  firstRowRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}, [
  searchTerm,
  selectedBrands,
  selectedBrandOrigins,
  selectedPrices,
  selectedCategories,
  selectedBrandRetailers,
  selectedAttributes,
  selectedTrends,
  selectedTimeRange,
  activeSortKey,
  sortDirection,
  currentPage,
]);
const totalPages = Math.ceil(sortedProducts.length / itemsPerPage);
const paginationRange = getPaginationRange(currentPage, totalPages);
const selectedFiltersArray = useMemo(() => {
  const filters = [];

  if (selectedDays) {
    const label = daysOptions.find(opt => opt.value === selectedDays)?.label;
    if (label) filters.push({ filter: 'Time Period', option: label });
  }

  if (selectedSegment) {
    filters.push({ filter: 'Segment', option: selectedSegment.segment_name });
  }

  if (searchTerm) {
    filters.push({ filter: 'Search', option: searchTerm });
  }

  selectedBrands.forEach(brand =>
    filters.push({ filter: 'Brand', option: brand })
  );

  selectedBrandOrigins.forEach(origin =>
    filters.push({ filter: 'Brand Origin', option: origin })
  );

  selectedPrices.forEach(price =>
    filters.push({ filter: 'Price', option: price })
  );

  selectedCategories.forEach(category =>
    filters.push({ filter: 'Category', option: category })
  );

  selectedBrandRetailers.forEach(retailer =>
    filters.push({ filter: 'Retailer History', option: retailer })
  );

  selectedAttributes.forEach(attribute =>
    filters.push({ filter: 'Attribute', option: attribute })
  );

  selectedTrends.forEach(trend =>
    filters.push({ filter: 'Trend', option: trend })
  );

  if (selectedTimeRange) {
    filters.push({ filter: 'New Launch', option: `${selectedTimeRange} months` });
  }

  if (props.newProducts && !isOn) {
    filters.push({ filter: 'Discontinued', option: 'Hidden' });
  }

  if (!props.newProducts && !isOnProducts) {
    filters.push({ filter: 'Reformulation/Repackaging', option: 'Hidden' });
  }

  return filters;
}, [
  selectedDays,
  selectedSegment,
  searchTerm,
  selectedBrands,
  selectedBrandOrigins,
  selectedPrices,
  selectedCategories,
  selectedBrandRetailers,
  selectedAttributes,
  selectedTrends,
  selectedTimeRange,
  isOn,
  isOnProducts,
  props.newProducts,
]);
useEffect(() => {
  if (prod?.docId && (isRestoring || loading)) return;

  const requestId = ++findMatchIdRef.current;

  const findMatch = async () => {
    const matchedView = findMatchingSavedView(selectedFiltersArray, fetchedData?.savedViews);

    if (matchedView && prod?.docId) {
      setAlreadySaved(true);
      // if (prod?.product_count !== sortedProducts.length) {
        await cosmeticIQApi.updatedata({
          id: prod?.docId,
          product_count: sortedProducts.length,
          type: 'products',
        });
        
        if (requestId !== findMatchIdRef.current) return;
        const resp = await cosmeticIQApi.fetchSavedViews();
        if (requestId !== findMatchIdRef.current) return;
        setData(prev => ({ ...prev, savedViews: resp }));
      // }
    } else {
      setAlreadySaved(matchedView ? true : false);
    }
  };

  findMatch();
}, [selectedFiltersArray, isRestoring, loading]);
useEffect(()=>{
  const matchedView = findMatchingSavedView(selectedFiltersArray, fetchedData?.savedViews);
  setAlreadySaved(matchedView);
  
},[selectedFiltersArray,isOpenSaveViewModal])

 const downloadCsv = () => {
        setIsCsvModalOpen(true);
    }
  return (
    <Container style={{ padding: props.newProducts ? '0px' : '30px'}}>
       <CsvModal
        isOpen={isCsvModalOpen}
        onClose={() => setIsCsvModalOpen(false)}
        fields={["Brand","Name","Discontinued","Price Range","Attributes","Brand Retailer History","Category","Ingredients",'Date Launched',"Description"]}
        data={sortedProducts} 
      />
      <RedirectModal isOpen={sessionExpired}/>
      <SaveViewModal productCount = {filteredProducts.length} data ={selectedFiltersArray} isOpen={isOpenSaveViewModal}onClose={()=>setIsOpenSaveViewModal(false)} />
      <Main style={{ 
          padding: props.newProducts ? '0px' : '24px',
          position: 'relative',
          maxHeight: '80vh',
          overflowY: 'auto' 
        }} ref={tableContainerRef}>
      
 <div >
    {!props.newProducts && <div style={{justifyContent:'space-between',display:'flex',alignItems:'center'}}>
     <div style={{display:'flex',gap:10,width:'100%'}} > 
    {
    alreadySaved ?
    <SaveView cursor={'not-allowed'} disabled={true}>
        <SavedFull/>
        <SaveViewTxt color='#202327'>
          Saved view
        </SaveViewTxt>
      </SaveView>
    :
    <SaveView cursor='pointer'  onClick={()=>setIsOpenSaveViewModal(true)}>
        <SaveReport/>
        <SaveViewTxt color='#20232799'>
          Save view
        </SaveViewTxt>
      </SaveView>  
    }
      <DownloadDiv onlyRefresh={!fetchedData?.userData?.access_download}>
                        {fetchedData?.userData?.access_download && sortedProducts.length < 100 &&
                        <div style={{display:'flex',gap:10}}>
                    <DownloadCsvButton onClick={downloadCsv}>
                      <DownloadIcon size = '20'/>
                       <DownloadCsvButtonTxt>Download as .csv</DownloadCsvButtonTxt>
                    </DownloadCsvButton>
                    </div>
                    
                    }
                    </DownloadDiv>
                    </div>
 <div style={{display:'flex',gap:10,width:'100%'}}   ref={dropdownContainerRef}>
 <DropdownWrapper style={{flex:1}}>
    <DropdownInput 
      style={{
        background: selectedDays 
          ? 'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)' 
          : '#FFFFFF'
      }} 
      onClick={() => {
  setIsDaysOpen(!isDaysOpen);
  setIsSegmentOpen(false);
}}
    >
      {selectedDays 
        ? daysOptions.find(opt => opt.value === selectedDays)?.label || "Select Days" 
        : "Select Days"}
      <DropdownIcon />
    </DropdownInput>
    <OptionsList isOpen={isDaysOpen}>
      {daysOptions.map((option, index) => (
        <DropdownOption
          key={option.value}
          onClick={() => handleDaysSelect(option)}
          style={{
            backgroundColor: selectedDays === option.value 
              ? '#E0F2FE' : 'white',
            borderTopLeftRadius: index === 0 ? "8px" : "0",
            borderTopRightRadius: index === 0 ? "8px" : "0",
            borderBottomLeftRadius: index === daysOptions.length - 1 ? "8px" : "0",
            borderBottomRightRadius: index === daysOptions.length - 1 ? "8px" : "0",
          }}
        >
          {option.label}
          {selectedDays === option.value && '✓'}
        </DropdownOption>
      ))}
    </OptionsList>
  </DropdownWrapper>
  <DropdownWrapper style={{flex:1}}>
  <DropdownInput
    onClick={() => {
  setIsSegmentOpen(!isSegmentOpen);
  setIsDaysOpen(false);
}}
    style={{
      background: selectedSegment
        ? "linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)"
        : "#F9F9F9",
    }}
  >
    {selectedSegment ? selectedSegment.segment_name : "Select Segment"}
    <DropdownIcon />
  </DropdownInput>

  <OptionsList isOpen={isSegmentOpen}>
    {segments?.map((segment, index) => (
      <DropdownOption
        key={segment.segment_id}
        onClick={() => {
  if (selectedSegment?.segment_id === segment.segment_id) {
    handleSegmentSelect(null); 
  } else {
    handleSegmentSelect(segment);
  }
}}
        style={{
          backgroundColor: selectedSegment?.segment_name === segment?.segment_name 
              ? '#E0F2FE' : 'white',
            borderBottomLeftRadius: index === segments.length - 1 ? "8px" : "0",
            borderBottomRightRadius: index === segments.length - 1 ? "8px" : "0",
        }}
      >
        {segment.segment_name}{selectedSegment?.segment_name === segment?.segment_name && " ✓"}
      </DropdownOption>
    ))}
  </OptionsList>
</DropdownWrapper>
<div style={{width:'5%',alignItems:"center",justifyContent:"center",display:'flex'}}>{loading && <Loader/>}</div>
</div>
      
      </div>}
      
      
    </div>
          {props.additionalResults && <SearchFlagView>
                                    {/* <Warn/> */}
                                    <AnP1Text style={{color:'#202327'}}>Too many results. Refine your search.</AnP1Text>
                                    </SearchFlagView>}
        <F>
        
            
          {isSmallScreen && <F1  style={{flexDirection:'column',gap:30}} ref={filtersRef}>
            <div style={{display:'flex',gap:10,flexDirection:'column'}}>
            <div style={{display:'flex',width:'100%',gap:10}}>
            <F11 style={{width:390,height:44,}}>
              <SearchIcon />
              <SearchInput
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </F11>
            
            
           {renderMultiSelectDropdown2(
  openDropdown === "Brand",
  () => setOpenDropdown(openDropdown === "Brand" ? null : "Brand"),
  selectedBrands,
  uniqueBrands,
  toggleBrandSelection,
  "Brand"
)}
              {
              
              renderMultiSelectDropdown2(
                openDropdown === "Brand Origin",
                () => setOpenDropdown(openDropdown === "Brand Origin" ? null : "Brand Origin"),
                selectedBrandOrigins,
                uniqueBrandOrigins,
                toggleBrandOriginSelection,
              "Brand Origin"
            )}
            {renderMultiSelectDropdown2(
              openDropdown === "Price",
              () => setOpenDropdown(openDropdown === "Price" ? null : "Price"),
              selectedPrices,
              priceOptions.map(p => "$".repeat(parseInt(p))),
              togglePriceSelection,
              "Price"
            )}
            </div>

                        <div style={{display:'flex',gap:10}}>
             {renderMultiSelectDropdown2(
              openDropdown === "Brand Retailers",
              () => setOpenDropdown(openDropdown === "Brand Retailers" ? null : "Brand Retailers"),
              selectedBrandRetailers, 
              uniqueBrandRetailers, 
              toggleBrandRetailerSelection, 
              "Retailer History"
            )}

            {renderMultiSelectDropdown2(
              openDropdown === "Category",
              () => setOpenDropdown(openDropdown === "Category" ? null : "Category"),
              selectedCategories,
              uniqueCategories,
              toggleCategorySelection,
              "Category"
            )}
            { renderMultiSelectDropdown2(
              openDropdown === "Trend",
              () => setOpenDropdown(openDropdown === "Trend" ? null : "Trend"),
              selectedTrends, 
              uniqueTrends, 
              toggleTrendSelection, 
              "Trend"
            )}
            {renderMultiSelectDropdown2(
              openDropdown === "Attribute",
              () => setOpenDropdown(openDropdown === "Attribute" ? null : "Attribute"),
              selectedAttributes,
              uniqueAttributes,
              toggleAttributeSelection,
              "Attribute"
            )}
             {
            props.newProducts &&
            renderMultiSelectDropdown(
              openDropdown === "Time",
              () => setOpenDropdown(openDropdown === "Time" ? null : "Time"),
              selectedTimeRange ? [selectedTimeRange + " months"] : [],
              ["3 months", "6 months", "12 months"],
              (rangeLabel) => {
                const num = rangeLabel.split(' ')[0];
    setSelectedTimeRange(prev => prev === num ? null : num);
  },
  "New Launch"
)}

            <ClearBtn onClick={clearFilters}>
              
            <CrossIcon/>
          </ClearBtn>
          </div>
          </div>
           <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',}}>
       {props.newProducts ?  isFilter ?
       <ResultTxt style={{margin:0}}>Filtered to <RsltSpan>{sortedProducts.length}</RsltSpan> results from the <RsltSpan>{fetchedData.resultCount}</RsltSpan> displayed (of <RsltSpan>{fetchedData.totalResultCount}</RsltSpan> total)</ResultTxt>:
       <ResultTxt style={{margin:0}}>Showing the first <RsltSpan>{fetchedData.resultCount}</RsltSpan> of <RsltSpan>{fetchedData.totalResultCount}</RsltSpan> total results</ResultTxt>:
         <ResultTxt style={{margin:0}}>Showing <RsltSpan>{sortedProducts.length}{
         (selectedAttributes.length > 0  ||selectedCategories.length > 0 || selectedBrands.length > 0 || selectedPrices.length > 0 || selectedBrandRetailers.length > 0 || searchTerm || selectedTimeRange) &&
         `/${data.newProducts.length}`} results</RsltSpan></ResultTxt>
}
         
         {props.newProducts ?
          <ToggleWrapper onClick={() => setIsOn(!isOn)}>
  <Label>Show discontinued products</Label>
      <Switch on={isOn} style={{width:30,height:17,padding:2}}>
        <Knob2 on={isOn} style={{width:13,height:13}}/>
        
      </Switch>
      
    </ToggleWrapper>
  :
  <ToggleWrapper onClick={() => setIsOnProducts(!isOnProducts)}>
  <Label>Show reformulation/repackaging</Label>
      <Switch on={isOnProducts} style={{width:30,height:17,padding:2}}>
        <Knob2 on={isOnProducts} style={{width:13,height:13}}/>
        
      </Switch>
      
    </ToggleWrapper>  
  }

    </div>
          </F1>}
          {!isSmallScreen &&
            <F1 ref={filtersRef}>
            <F11>
              <SearchIcon />
              <SearchInput
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </F11>
            
            
           {renderMultiSelectDropdown(
  openDropdown === "Brand",
  () => setOpenDropdown(openDropdown === "Brand" ? null : "Brand"),
  selectedBrands,
  uniqueBrands,
  toggleBrandSelection,
  "Brand"
)}
              {
              
              renderMultiSelectDropdown(
                openDropdown === "Brand Origin",
                () => setOpenDropdown(openDropdown === "Brand Origin" ? null : "Brand Origin"),
                selectedBrandOrigins,
                uniqueBrandOrigins,
                toggleBrandOriginSelection,
              "Brand Origin"
            )}

            {renderMultiSelectDropdown(
              openDropdown === "Price",
              () => setOpenDropdown(openDropdown === "Price" ? null : "Price"),
              selectedPrices,
              priceOptions.map(p => "$".repeat(parseInt(p))),
              togglePriceSelection,
              "Price"
            )}
             {renderMultiSelectDropdown(
              openDropdown === "Brand Retailers",
              () => setOpenDropdown(openDropdown === "Brand Retailers" ? null : "Brand Retailers"),
              selectedBrandRetailers, 
              uniqueBrandRetailers, 
              toggleBrandRetailerSelection, 
              "Retailer History"
            )}

            {renderMultiSelectDropdown(
              openDropdown === "Category",
              () => setOpenDropdown(openDropdown === "Category" ? null : "Category"),
              selectedCategories,
              uniqueCategories,
              toggleCategorySelection,
              "Category"
            )}
            { renderMultiSelectDropdown(
              openDropdown === "Trend",
              () => setOpenDropdown(openDropdown === "Trend" ? null : "Trend"),
              selectedTrends, 
              uniqueTrends, 
              toggleTrendSelection, 
              "Trend"
            )}
            {renderMultiSelectDropdown(
              openDropdown === "Attribute",
              () => setOpenDropdown(openDropdown === "Attribute" ? null : "Attribute"),
              selectedAttributes,
              uniqueAttributes,
              toggleAttributeSelection,
              "Attribute"
            )}
             {
            props.newProducts &&
            renderMultiSelectDropdown(
              openDropdown === "Time",
              () => setOpenDropdown(openDropdown === "Time" ? null : "Time"),
              selectedTimeRange ? [selectedTimeRange + " months"] : [],
              ["3 months", "6 months", "12 months"],
              (rangeLabel) => {
                const num = rangeLabel.split(' ')[0];
    setSelectedTimeRange(prev => prev === num ? null : num);
  },
  "New Launch"
)}
            <ClearBtn onClick={clearFilters}>
            <CrossIcon/>
          </ClearBtn>
          </F1>}
          
        </F>
     {!isSmallScreen &&   <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'0px 30px'}}>
       {props.newProducts ?  isFilter ?
       <ResultTxt>Filtered to <RsltSpan>{sortedProducts.length}</RsltSpan> results from the <RsltSpan>{fetchedData.resultCount}</RsltSpan> displayed (of <RsltSpan>{fetchedData.totalResultCount}</RsltSpan> total)</ResultTxt>:
       <ResultTxt>Showing the first <RsltSpan>{fetchedData.resultCount}</RsltSpan> of <RsltSpan>{fetchedData.totalResultCount}</RsltSpan> total results</ResultTxt>:
         <ResultTxt>Showing <RsltSpan>{sortedProducts.length}{
         (selectedAttributes.length > 0  ||selectedCategories.length > 0 || selectedBrands.length > 0 || selectedPrices.length > 0 || selectedBrandRetailers.length > 0 || searchTerm || selectedTimeRange) &&
         `/${data.newProducts.length}`} results</RsltSpan></ResultTxt>
}
         
         {props.newProducts ?
          <ToggleWrapper onClick={() => setIsOn(!isOn)}>
  <Label>Show discontinued products</Label>
      <Switch on={isOn}>
        <Knob on={isOn} />
        
      </Switch>
      
    </ToggleWrapper>
  :
  <ToggleWrapper onClick={() => setIsOnProducts(!isOnProducts)}>
  <Label>Show reformulation/repackaging</Label>
      <Switch on={isOnProducts}>
        <Knob on={isOnProducts} />
        
      </Switch>
      
    </ToggleWrapper>  
  }

    </div>}
        <ProductModal
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
      />
      <TableWrapper ref={tableContainerRef}>
        {!isSmallScreen ? <Table  ref={firstRowRef}>
          <THead>
            <TR>
              <TH>
                <THContent>
                  <Span>Product Name</Span>
                  {getSortIcon("name")}
                </THContent>
              </TH>
              
              <TH>
                <THContent>
                  <Span>Brand</Span>
                  {getSortIcon("brand")}
                </THContent>
              </TH>
                <TH>
                <THContent>
                  <Span>Brand Origin</Span>
                  {getSortIcon("brand_origin")}
                </THContent>
              </TH>
              {!props.newProducts && <TH>
                <THContent>
                  <Span>Date Added</Span>
                  {getSortIcon("dateAdded")}
                </THContent>
              </TH>}
               {<TH>
                <THContent>
                  <Span>Date Launched</Span>
                  {getSortIcon("dateLaunched")}
                </THContent>
              </TH>}
               
              <TH>
                <THContent>
                  <Span>Price</Span>
                  {getSortIcon("price")}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Brand Retailer History</Span>
                  {getSortIcon("brand_retailers")}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Category</Span>
                  {getSortIcon("category")}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Trend</Span>
                  {getSortIcon("trend")}
                </THContent>
              </TH>
              <TH>
                <THContent>
                  <Span>Attribute</Span>
                  {getSortIcon("attribute")}
                </THContent>
              </TH>
             {/* {props.newProducts && <TH>
                <THContent>
                  <Span>Ingredient list</Span>
                  {getSortIcon("ingredients")}
                </THContent>
              </TH>} */}
            </TR>
          </THead>
          <TBody  >
          {
        
          (paginatedProducts.map((product,index) => (
  <TR
  key={product.id}
 
>
          
         
  
    <TD  key={product.id} onClick={() => handleRowClick(product)}>
      <ProductCell>
        <ProductImage>
          <Img
            src={product.image.fullsize}
            height={58}
            width={58}
            alt={product.name}
          />
          
            {product.discontinued === "1" &&
            
            
            <Overlay>
              <OverlayTxt>
              DISCONTINUED
              </OverlayTxt>
              </Overlay>}

        </ProductImage>
        <ProductInfo>
          {/* <ProductName>{product.name}</ProductName> */}
          <ProductDescription>
          {product.name}
          </ProductDescription>
        </ProductInfo>
      </ProductCell>
    </TD>
   
    <TD>{product.brand}</TD>
     <TD>{product.brand_origin ? product.brand_origin : '-'}</TD>
    {!props.newProducts &&<TD style={{ color: "#2F323799" }}>{product.date_created.split(' ')[0]}</TD>}
     <TD style={{ color: "#2F323799" }}>{product.date_launched}</TD>
    
    <TD>
    <PriceWrapper>
    {[...Array(Number(product.priceRange || 0))].map((_, index) => (
      <Dollar key={index} />
    ))}
  </PriceWrapper>
    </TD>
    <TD>{product.brand_retailers.map(brand_retailer => brand_retailer.name).join(", ") || '-'}</TD>
    <TD>{product.categories.map(cat => cat.name).join(", ") || '-'}</TD>
    <TD>
  {product.attributes
    .filter(cat =>  cat.type === 'Trend')
    .map(cat => cat.name)
    .join(", ") || '-'}
</TD>
 <TD>
  {product.attributes
    .filter(cat => cat.type !== 'Internal' && cat.type !== 'Trend')
    .map(cat => cat.name)
    .join(", ") || '-'}
</TD>

   {/* {props.newProducts &&
    <TD onClick={()=>toggleTruncate(product.id)} style={{ color: "#2F323799", whiteSpace: 'normal', wordBreak: 'break-word' }}>
  {truncatedStates[product.id] 
    ? product.ingredients
    : product.ingredients.slice(0, 37) + '...'}
</TD>} */}
  </TR>


          
          )))}
          </TBody>
        </Table> :
        <Table  ref={firstRowRef}>
          <THead>
            <TR>
              <TH>
                <THContent>
                  <Span>Product Info</Span>
                  {getSortIcon("name")}
                </THContent>
              </TH>
            
               {<TH>
                <THContent>
                  <Span>Launch date</Span>
                  {getSortIcon("dateLaunched")}
                </THContent>
              </TH>}
              <TH>
                <THContent>
                  <Span>Brand</Span>
                  {getSortIcon("brand")}
                </THContent>
              </TH>
               
              <TH>
                <THContent>
                  <Span>Price</Span>
                  {getSortIcon("price")}
                </THContent>
              </TH>
              
              <TH>
                <THContent>
                  <Span>Category</Span>
                  {getSortIcon("category")}
                </THContent>
              </TH>
              
            </TR>
          </THead>
          <TBody  >
          {
        
          (paginatedProducts.map((product,index) => (
  <TR 
  key={product.id}
  
>
          
         
  
    <TD  key={product.id} onClick={() => handleRowClick(product)}>
      <ProductCell>
        <ProductImage>
          <Img
            src={product.image.fullsize}
            height={58}
            width={58}
            alt={product.name}
          />
          
            {product.discontinued === "1" &&
            
            
            <Overlay>
              <OverlayTxt>
              DISCONTINUED
              </OverlayTxt>
              </Overlay>}

        </ProductImage>
        <ProductInfo>
          {/* <ProductName>{product.name}</ProductName> */}
          <ProductDescription>
          {product.name}
          </ProductDescription>
        </ProductInfo>
      </ProductCell>
    </TD>
   
    
    
    
     <TD style={{ color: "#2F323799" }}>{product.date_launched}</TD>
    
    
      <TD>{product.brand}</TD>
    <TD>
    <PriceWrapper>
    {[...Array(Number(product.priceRange || 0))].map((_, index) => (
      <Dollar key={index} />
    ))}
  </PriceWrapper>
    </TD>
    
    <TD>{product.categories.map(cat => cat.name).join(", ") || '-'}</TD>
    
   {/* {props.newProducts &&
    <TD onClick={()=>toggleTruncate(product.id)} style={{ color: "#2F323799", whiteSpace: 'normal', wordBreak: 'break-word' }}>
  {truncatedStates[product.id] 
    ? product.ingredients
    : product.ingredients.slice(0, 37) + '...'}
</TD>} */}
  </TR>


          
          )))}
          </TBody>
        </Table> 
        }
   
        </TableWrapper>
               {visibleProducts < sortedProducts.length && (
      
      totalPages > 1 && (
  <PaginationWrapper>
    
    {currentPage > 1 && (
      <PageButton onClick={() => setCurrentPage(prev => Math.min(prev - 1, totalPages))}>
        <Left/>
      </PageButton>
    )}

    {paginationRange.map((page, index) => {
      if (page === '...') {
        return (
          <EllipsesSpacer key={`dots-${index}`} style={{ padding: '0 8px', color: '#2F323799' }}>
            ...
          </EllipsesSpacer>
        );
      }

      return (
        <PageButton
          key={`page-${page}`}
          active={currentPage === page}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </PageButton>
      );
    })}

    
   {currentPage < totalPages && (
      <PageButton onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
        <Right/>
      </PageButton>
    )}
  </PaginationWrapper>
)
       
    )}
      
       {showBackToTop && (
          <BackToTopButton onClick={scrollToTop}>
            <img src={BackToTopIcon} alt='backToTopIcon' width={50} height={50}/>
          </BackToTopButton>
        )} 
      </Main>
     
      
    </Container>
  );
};

export default NewlyLaunchedProducts;
const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: row;
  gap: 8px;
  user-select: none;
`;

const PageButton = styled.button`
outline:none;
border:none;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  // padding: 0 8px;
  
  font-size: 14px;
  font-weight: 600;
  color: ${({ active }) => (active ? "#202327" : "#2F323799")};
  cursor: pointer;
  border-radius: ${({ active }) => (active ? "100px" : "0px")};
  
  background: ${({ active }) => (
    active 
      ? "#F9F9F9" 
      : "transparent"
  )};
  


  
`;

const EllipsesSpacer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #94A3B8;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
`;
const BackToTopButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #F9F9F9;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 1000;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;
const Container = styled.div`

gap: 30px;
border: 0px 1px 0px 0px;
opacity: 0px;
// height:100%;

`
const NoneDiv = styled.div`
  width: 100%; // Stretch across full width
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1/ -1; 
`;
const NoneTxt = styled.p`

font-weight: 600;
font-size: 32px;
line-height: 110.00000000000001%;
letter-spacing: -1%;
color: #202327;
`
const TableWrapper = styled.div`
  // max-height: 70vh;
  border-radius: 18px;
  position: relative;
   overflow: auto;
   background: #F9F9F9;
  
  
  &::-webkit-scrollbar {
    width: 4px;  /* Increased width for better visibility */
  }
  
  &::-webkit-scrollbar-track {
    background: #grey;  /* Visible track color */
    border-radius: 1px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: black;
    border-radius: 1px;
  }
  
  
  scrollbar-width: thin;
  scrollbar-color: black #grey;  /* Thumb and track color */
  
`;


const THead = styled.thead`
font-family:PPMori;
 position: sticky;
 top: 0;
 z-index: 10;
 background: #F9F9F9;
// display: flex;`
const TBody = styled.tbody`font-family:PPMori;`
const Span = styled.span`font-family:PPMori;`
const Img = styled.img`object-fit: contain;`
const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SearchFlagView = styled.div`
// background:red;
display:flex;
align-self:center;
align-items:center;
gap: 10px;
`
const AnP1Text = styled.p`

font-size: 14px;
font-weight: 600;
line-height: 16.8px;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;
`
const Switch = styled.div`
  width: 50px;
  height: 26px;
  border-radius: 50px;
  background-color: ${props => (props.on ? '#BDDEFF' : '#ccc')};
  padding: 3px;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const Knob = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  transform: ${props => (props.on ? 'translateX(24px)' : 'translateX(0)')};
  transition: all 0.3s ease;
`;
const Knob2 = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  transform: ${props => (props.on ? 'translateX(13px)' : 'translateX(0)')};
  transition: all 0.3s ease;
`;
const Label = styled.span`
  font-size: 14px;
font-weight: 500;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #202327;

`;

const Main = styled.div`

gap: 24px;
border-radius: 24px;
background: #FFFFFF;
// overflow:scroll;
 overflow: hidden;
box-shadow: 0px 0px 24px 0px #2F323705;
height:100%;
display:flex;

flex-direction:column;



opacity: 0px;
`

const ClearBtn = styled.button`
background: none;
cursor:pointer;
border:none;
`
const LoadMoreDiv = styled.div`
  
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 0px;
  background: #F9F9F9;
  width: 100%;
  min-width: 100%; /* Ensures it spans the wrapper */
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;
const LoadMoreButton = styled.button`
cursor:pointer;
border:none;
padding: 0px 20px 0px 16px;
flex-direction:row;display:flex;
align-items:center;
justifySelf: start;
gap: 8px;
border-radius: 1000px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);

`
const LoadMoreButtonTxt= styled.p`
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #202327;


`
const F = styled.div`

padding: 30px;
display:flex;

gap: 30px;
border-radius: 18px;
justify-content:space-between;
align-items:center;
// overflow-x: auto;  /* Allow horizontal scrolling */
//   overflow-y: hidden; /* Prevent vertical scrolling */




background: #F9F9F9;
@media (max-width: 1080px) {
    
    padding: 12px 12px;
    width:1000px
  }


`

const F1 = styled.div`

display:flex;

// gap: px;

width:100%;
`

const F11 = styled.div`

padding: 12px;
display:flex;
align-items:center;
gap: 8px;
height: 40px;
border-radius: 12px;
background: #FFFFFF;

`

const SearchInput = styled.input`
font-family:PPMori;
font-size: 14px;
font-weight: 600;
line-height: 16.8px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#20232799;
border:none;
outline: none;

`
const Table = styled.table`
  // width: max-content;   /* important for horizontal scroll */
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #F9F9F9;
  border-radius: 18px;
`;

const RsltSpan= styled.span`

font-weight: 600;
font-size: 14px;
line-height: 120%;
letter-spacing: -1%;
color: #202327;
`
const DownloadDiv = styled.div`
width: 100%;
height: 40px;
gap: 0px;
display:flex;

 justify-content: ${props => props.onlyRefresh ? 'flex-end' : 'space-between'};
align-items:center;

opacity: 0px;


`
const DownloadCsvButton = styled.button`
// width: 222px;
height: 40px;
cursor:pointer;
border:none;
padding: 0px 20px 0px 16px;
flex-direction:row;display:flex;
align-items:center;
justifySelf: start;
gap: 8px;
border-radius: 1000px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);

`
const DownloadCsvButtonTxt= styled.p`
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #202327;

`
const ResultTxt= styled.p`

font-weight: 600;
font-size: 14px;
line-height: 120%;
letter-spacing: -1%;
color: #20232799;
margin: 0px 30px;

`
const TR = styled.tr`
cursor: pointer;
font-family:PPMori;
  border-top: 1px solid #0000001A;
  &:first-child {
    border-top: none;
  }
`;

const TH = styled.th`
  padding: 30px;
  text-align: left;
  font-weight: 600;
  font-family: PPMori;
  background: #F9F9F9;
  

  position: sticky;
  top: 0;
  z-index: 10;

  &:first-child {
    left: 0;
    z-index: 20; /* higher than other headers */
   
  }
`;

const THContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const TD = styled.td`
  padding: 20px 30px;
  font-size: 16px;
  font-weight: 500;
  color: #202327;
  background: #F9F9F9;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 5;
    background: #F9F9F9;
  }
`;


const FilterButton = styled.button`
  background: #F9F9F9;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
`;

const ProductCell = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const ProductImage = styled.div`
  position: relative;
  padding: 6px;
  background: white;
  border-radius: 12px;
  // overflow: hidden;
  
`;

const OverlayTxt = styled.p`
font-family: PPMori;
font-weight: 800;
font-size: 10px;
line-height: 10px;
letter-spacing: -1%;
margin:0;
color: rgba(32, 35, 39, 1);


`
const Overlay = styled.div`
  position: absolute;
  
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-15deg);
  background:rgba(255, 255, 255, 1);
  color: black;
  font-weight: bold;
  font-size: 12px;
  padding: 2px 6px;
  height: 17px;
  // width:103px;
  border-radius: 4px;
  z-index: 2;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;



const ProductDescription = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #202327;
  letter-spacing: -0.01em;
`;

const PriceWrapper = styled.div`
  display: flex;
  gap: 4px;
  
`;
const SaveView = styled.button`
border:none;
cursor:${props=>props.cursor};
width: 133px;
height: 43px;
background: #F9F9F9;
angle: 0 deg;
opacity: 1;
display: flex;
align-items: center;
justify-content: center;
border-radius: 12px;
gap: 8px;
`
const SaveViewTxt = styled.p`
font-family: PP Mori;
font-weight: 600;
font-style: SemiBold;
font-size: 14px;
leading-trim: NONE;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color:${props=>props.color};
`
const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  padding-right:12px;
  padding-left:12px;

   white-space: normal;        
  word-break: break-word;    
  overflow-wrap: break-word; 

  
`;

const DropdownInput = styled.div`
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  color: #20232799;
  border: 1px solid #d1d1d1;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
  align-items: center;
  padding: 12px;
  

gap: 0px;
border-radius: 12px;
display:flex;


  
border:none;
  outline:none;
  &:hover {
    border-color: #000; /* Optional hover effect */
  }
`;

const OptionsList = styled.ul`
  position: absolute;
  
  top: calc(100% + 4px);
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0px ;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(24, 25, 26, 0.1);
  z-index: 10000000;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  
`;

const DropdownOption = styled.li`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #202327;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    
    
  }
`;





